import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { RedirectError } from '#src/shared/error';

import {
	Subscriptions,
	type SubscriptionsQuery,
	type SubscriptionsQueryVariables,
} from './contributionsPageData.graphql';
import { processData } from './processData';
import { type ContributionsPageData, ContributionsPageDataError } from './types';

export async function getContributionsPageData(utilityContext: UtilityContext): Promise<ContributionsPageData> {
	const {
		gql: { fetch },
		i18n,
	} = utilityContext;

	const { data } = await fetch<SubscriptionsQuery, SubscriptionsQueryVariables>({
		query: Subscriptions,
		rejectOnError: true,
	});

	if (!data.viewer.user?.subscriptions.length) {
		throw new RedirectError({ url: '/account_settings', reason: 'no_subscriptions' });
	}

	if (!data.featureConfigs.subscriptionConfiguration) {
		throw new ContributionsPageDataError('contributions_page_data_not_found');
	}

	return {
		...processData(
			{
				subscription: data.viewer.user.subscriptions[0],
				country: data.viewer.user.country,
			},
			data.featureConfigs.subscriptionConfiguration,
			data.featureConfigs.annualContributionsConfig,
			i18n,
		),
		featureConfigs: data.featureConfigs,
	};
}
